<template>
  <div class="progress-loader" :class="{ inactive }">
    <div class="progress-loader-overlay"></div>
    <div class="progress-loader-bar" :style="{ width: calcWidth }"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressLoader',
  props: {
    percent: {
      type: Number,
      default: () => 0,
    },
    inactive: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    calcWidth() {
      const value = this.percent > 100 ? 100 : this.percent;

      return `${value}%`;
    },
  },
};
</script>

<style lang="sass" scoped>
  .progress-loader
    height: 10px
    position: relative
    overflow: hidden
    border-radius: 50px

  .progress-loader-bar
    width: 100%
    height: 100%
    position: absolute
    top: 0
    left: 0
    background: linear-gradient(249.76deg, #37B55E -8.32%, #7BD3FF 108.85%), #FFF

    #{'.inactive'} &
      background: linear-gradient(241.39deg, #E81840 -0.37%, #9B51E0 96%)

  .progress-loader-overlay
    width: 100%
    height: 100%
    position: absolute
    top: 0
    left: 0
    background-color: #212121
</style>
